const ITEMS = ['Imagine', 'Aligne', 'Agis', 'Éclos', "Il n'est jamais trop tard pour éclore"];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS, ...ITEMS];
    return (
        <div className="overflow-hidden border-y border-champagne/30 bg-bordeaux py-4" data-testid="editorial-marquee" aria-hidden="true">
            <div className="marquee-track">
                {[0, 1].map((half) => (
                    <div key={half} className="flex shrink-0 items-center">
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span className="whitespace-nowrap px-8 text-serifit text-lg tracking-wide text-creme/90 sm:text-xl">
                                    {item}
                                </span>
                                <span className="text-champagne">✦</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
